import { InjectionToken } from '@angular/core';

export interface SheetsConfig {
  base: string; // '/api/sheets' en browser; 'https://sheets.googleapis.com' en SSR
  key: string;  // vacía en browser; la key real en SSR
}

export const SHEETS_CONFIG = new InjectionToken<SheetsConfig>('SHEETS_CONFIG');
